var map = {
	"./icjia-logo-125.png": "afa7",
	"./icjia-logo-white.png": "b70d",
	"./icjia-logo.png": "212e",
	"./ifvcc-logo-purple.png": "87f5",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./r3.png": "fa66",
	"./spac-default.png": "d98a",
	"./state-seal-color.png": "7787"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";